import {
    ReplyListApiV1CollaborationAppReplyGetQueryParams,
    useReplyListApiV1CollaborationAppReplyGetInfinite,
} from '../gen/base'

const DEFAULT_LIMIT = 10

export const useInfiniteReplyListQuery = (
    params: ReplyListApiV1CollaborationAppReplyGetQueryParams,
) => {
    const limit = params.limit ?? DEFAULT_LIMIT

    return useReplyListApiV1CollaborationAppReplyGetInfinite(
        { ...params, limit },
        {},
        {
            query: {
                getNextPageParam: (lastPage, allPages) =>
                    lastPage.offset + limit <= lastPage.total_count
                        ? allPages.length * limit
                        : null,
                initialPageParam: 0,
            },
        },
    )
}
